export default "__VITE_ASSET__qrvbK1$c__"